<template>
    <div class="chat-list">
        <chat-list-item v-for="item in sort_list" :online="super_admin_online.length > 0" :data="item" :key="item.id"></chat-list-item>
        <transition name="fade">
            <div v-if="page_loading" class="page-loader">
                <img src="../assets/loading-process.svg" alt="">
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import ChatListItem from './ChatListItem'

export default {
    components: {
        ChatListItem
    },
    computed: {
        ...mapState(['super_admin_online']),
        ...mapState('chatList', ['page_loading']),
        ...mapGetters('chatList', ['sort_list'])
    }
}
</script>

<style lang="scss" scoped>
    .chat-list { position: relative; overflow-x: hidden; overflow-y: hidden;
        .page-loader { height: 100px; display: flex; justify-content: center; align-items: center;
            img, svg { width: 50%; height: 50%; transform: scale(.75); 
                animation: cyc 2s infinite cubic-bezier(0.645, 0.045, 0.355, 1);
            }
        }
        @keyframes cyc {
            0% { transform: scale(.75) rotate(0deg);}
            100% { transform: scale(.75) rotate(360deg);}
        }
    }
.fade-enter-active, .fade-leave-active {
  transition: all .55s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: translateY(15px);
}
</style>


// WEBPACK FOOTER //
// src/components/ChatList.vue